import React, { useState } from 'react';
import { MapPinIcon, CheckCircleIcon, TruckIcon } from 'lucide-react';
const DeliveryDashboard = () => {
  const [activeTab, setActiveTab] = useState('available');
  // Sample delivery orders data
  const availableOrders = [{
    id: 'ORD-12345',
    customer: 'John Doe',
    address: '123 Main Street, Apt 4B, Makati City, Metro Manila, Philippines 1234',
    items: [{
      name: 'Kare-Kare',
      quantity: 1
    }, {
      name: 'Lumpiang Shanghai',
      quantity: 2
    }],
    total: 619.0,
    distance: '1.2 km',
    estimatedTime: '15-20 min'
  }, {
    id: 'ORD-12346',
    customer: 'Maria Santos',
    address: '456 Corporate Tower, 10th Floor, Bonifacio Global City, Taguig, Metro Manila, Philippines',
    items: [{
      name: 'Bulalo',
      quantity: 1
    }, {
      name: 'Halo-Halo',
      quantity: 1
    }, {
      name: 'Leche Flan',
      quantity: 1
    }],
    total: 540.0,
    distance: '2.5 km',
    estimatedTime: '20-25 min'
  }];
  const assignedOrders = [{
    id: 'ORD-12340',
    customer: 'Pedro Reyes',
    address: '789 Residential Complex, Unit 12, Pasig City, Metro Manila, Philippines',
    items: [{
      name: 'Sinigang',
      quantity: 1
    }, {
      name: 'Ensaladang Talong',
      quantity: 1
    }],
    total: 400.0,
    status: 'Out for Delivery',
    assignedAt: '15:30'
  }];
  const completedOrders = [{
    id: 'ORD-12335',
    customer: 'Ana Lim',
    address: '321 Condominium, 5th Floor, Quezon City, Metro Manila, Philippines',
    items: [{
      name: 'Kare-Kare',
      quantity: 1
    }, {
      name: 'Halo-Halo',
      quantity: 2
    }],
    total: 559.0,
    completedAt: '14:15'
  }, {
    id: 'ORD-12330',
    customer: 'Juan Reyes',
    address: '567 Business Park, Building B, Mandaluyong City, Metro Manila, Philippines',
    items: [{
      name: 'Bulalo',
      quantity: 1
    }],
    total: 340.0,
    completedAt: '13:45'
  }];
  return <div className="bg-gray-50 min-h-screen" data-id="element-1053">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1054">
        <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-1055">
          {/* Dashboard Header */}
          <div className="px-6 py-4 border-b border-gray-200" data-id="element-1056">
            <h1 className="text-2xl font-semibold text-gray-800" data-id="element-1057">
              Delivery Dashboard
            </h1>
            <p className="text-sm text-gray-600" data-id="element-1058">Welcome, Delivery Staff</p>
          </div>
          {/* Dashboard Tabs */}
          <div className="border-b border-gray-200" data-id="element-1059">
            <nav className="flex -mb-px" data-id="element-1060">
              <button onClick={() => setActiveTab('available')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'available' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1061">
                Available Orders
              </button>
              <button onClick={() => setActiveTab('assigned')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'assigned' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1062">
                My Assigned Orders
              </button>
              <button onClick={() => setActiveTab('completed')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'completed' ? 'border-orange-500 text-orange-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1063">
                Completed Orders
              </button>
            </nav>
          </div>
          {/* Dashboard Content */}
          <div className="p-6" data-id="element-1064">
            {activeTab === 'available' && <div data-id="element-1065">
                <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1066">
                  Available Orders for Pickup
                </h2>
                {availableOrders.length === 0 ? <div className="text-center py-12" data-id="element-1067">
                    <p className="text-gray-500" data-id="element-1068">
                      No available orders at the moment.
                    </p>
                  </div> : <div className="space-y-6" data-id="element-1069">
                    {availableOrders.map(order => <div key={order.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1070">
                        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center" data-id="element-1071">
                          <div data-id="element-1072">
                            <span className="font-semibold text-gray-900" data-id="element-1073">
                              {order.id}
                            </span>
                          </div>
                          <div className="flex items-center" data-id="element-1074">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1075">
                              Ready for Pickup
                            </span>
                          </div>
                        </div>
                        <div className="p-4" data-id="element-1076">
                          <div className="mb-4" data-id="element-1077">
                            <h3 className="font-medium text-gray-900" data-id="element-1078">
                              Customer Information
                            </h3>
                            <p className="text-sm text-gray-600 mt-1" data-id="element-1079">
                              {order.customer}
                            </p>
                          </div>
                          <div className="mb-4" data-id="element-1080">
                            <h3 className="font-medium text-gray-900" data-id="element-1081">
                              Delivery Address
                            </h3>
                            <div className="flex items-start mt-1" data-id="element-1082">
                              <MapPinIcon className="h-5 w-5 text-gray-400 mr-1 flex-shrink-0" data-id="element-1083" />
                              <p className="text-sm text-gray-600" data-id="element-1084">
                                {order.address}
                              </p>
                            </div>
                          </div>
                          <div className="mb-4" data-id="element-1085">
                            <h3 className="font-medium text-gray-900" data-id="element-1086">
                              Order Summary
                            </h3>
                            <ul className="mt-1 space-y-1" data-id="element-1087">
                              {order.items.map((item, index) => <li key={index} className="text-sm text-gray-600" data-id="element-1088">
                                  {item.quantity} x {item.name}
                                </li>)}
                            </ul>
                          </div>
                          <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-1089">
                            <div data-id="element-1090">
                              <h3 className="font-medium text-gray-900" data-id="element-1091">
                                Order Total
                              </h3>
                              <p className="text-sm text-gray-600 mt-1" data-id="element-1092">
                                ₱{order.total.toFixed(2)}
                              </p>
                            </div>
                            <div data-id="element-1093">
                              <h3 className="font-medium text-gray-900" data-id="element-1094">
                                Distance
                              </h3>
                              <p className="text-sm text-gray-600 mt-1" data-id="element-1095">
                                {order.distance}
                              </p>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-1096">
                            <div data-id="element-1097">
                              <h3 className="font-medium text-gray-900" data-id="element-1098">
                                Estimated Delivery Time
                              </h3>
                              <p className="text-sm text-gray-600 mt-1" data-id="element-1099">
                                {order.estimatedTime}
                              </p>
                            </div>
                          </div>
                          <div className="mt-4 flex justify-end" data-id="element-1100">
                            <button className="px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700" data-id="element-1101">
                              Accept Order
                            </button>
                          </div>
                        </div>
                      </div>)}
                  </div>}
              </div>}
            {activeTab === 'assigned' && <div data-id="element-1102">
                <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1103">
                  My Assigned Orders
                </h2>
                {assignedOrders.length === 0 ? <div className="text-center py-12" data-id="element-1104">
                    <p className="text-gray-500" data-id="element-1105">
                      You have no assigned orders at the moment.
                    </p>
                  </div> : <div className="space-y-6" data-id="element-1106">
                    {assignedOrders.map(order => <div key={order.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1107">
                        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center" data-id="element-1108">
                          <div data-id="element-1109">
                            <span className="font-semibold text-gray-900" data-id="element-1110">
                              {order.id}
                            </span>
                            <span className="text-sm text-gray-500 ml-2" data-id="element-1111">
                              Assigned at {order.assignedAt}
                            </span>
                          </div>
                          <div className="flex items-center" data-id="element-1112">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-1113">
                              {order.status}
                            </span>
                          </div>
                        </div>
                        <div className="p-4" data-id="element-1114">
                          <div className="mb-4" data-id="element-1115">
                            <h3 className="font-medium text-gray-900" data-id="element-1116">
                              Customer Information
                            </h3>
                            <p className="text-sm text-gray-600 mt-1" data-id="element-1117">
                              {order.customer}
                            </p>
                          </div>
                          <div className="mb-4" data-id="element-1118">
                            <h3 className="font-medium text-gray-900" data-id="element-1119">
                              Delivery Address
                            </h3>
                            <div className="flex items-start mt-1" data-id="element-1120">
                              <MapPinIcon className="h-5 w-5 text-gray-400 mr-1 flex-shrink-0" data-id="element-1121" />
                              <p className="text-sm text-gray-600" data-id="element-1122">
                                {order.address}
                              </p>
                            </div>
                            <div className="mt-2" data-id="element-1123">
                              <button className="text-sm text-blue-600 hover:text-blue-800 flex items-center" data-id="element-1124">
                                <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1125">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" data-id="element-1126"></path>
                                </svg>
                                Open in Maps
                              </button>
                            </div>
                          </div>
                          <div className="mb-4" data-id="element-1127">
                            <h3 className="font-medium text-gray-900" data-id="element-1128">
                              Order Summary
                            </h3>
                            <ul className="mt-1 space-y-1" data-id="element-1129">
                              {order.items.map((item, index) => <li key={index} className="text-sm text-gray-600" data-id="element-1130">
                                  {item.quantity} x {item.name}
                                </li>)}
                            </ul>
                          </div>
                          <div className="mb-4" data-id="element-1131">
                            <h3 className="font-medium text-gray-900" data-id="element-1132">
                              Order Total
                            </h3>
                            <p className="text-sm text-gray-600 mt-1" data-id="element-1133">
                              ₱{order.total.toFixed(2)}
                            </p>
                          </div>
                          <div className="mt-4" data-id="element-1134">
                            <h3 className="font-medium text-gray-900 mb-2" data-id="element-1135">
                              Update Order Status
                            </h3>
                            <div className="flex space-x-4" data-id="element-1136">
                              <button className="flex items-center px-3 py-2 bg-yellow-100 text-yellow-800 rounded-md" data-id="element-1137">
                                <TruckIcon className="h-4 w-4 mr-2" data-id="element-1138" />
                                Out for Delivery
                              </button>
                              <button className="flex items-center px-3 py-2 bg-gray-100 text-gray-800 rounded-md" data-id="element-1139">
                                <CheckCircleIcon className="h-4 w-4 mr-2" data-id="element-1140" />
                                Delivered
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>)}
                  </div>}
              </div>}
            {activeTab === 'completed' && <div data-id="element-1141">
                <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1142">
                  Completed Orders
                </h2>
                {completedOrders.length === 0 ? <div className="text-center py-12" data-id="element-1143">
                    <p className="text-gray-500" data-id="element-1144">
                      You have no completed orders yet.
                    </p>
                  </div> : <div className="space-y-6" data-id="element-1145">
                    {completedOrders.map(order => <div key={order.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1146">
                        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center" data-id="element-1147">
                          <div data-id="element-1148">
                            <span className="font-semibold text-gray-900" data-id="element-1149">
                              {order.id}
                            </span>
                            <span className="text-sm text-gray-500 ml-2" data-id="element-1150">
                              Completed at {order.completedAt}
                            </span>
                          </div>
                          <div className="flex items-center" data-id="element-1151">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1152">
                              Delivered
                            </span>
                          </div>
                        </div>
                        <div className="p-4" data-id="element-1153">
                          <div className="mb-4" data-id="element-1154">
                            <h3 className="font-medium text-gray-900" data-id="element-1155">
                              Customer Information
                            </h3>
                            <p className="text-sm text-gray-600 mt-1" data-id="element-1156">
                              {order.customer}
                            </p>
                          </div>
                          <div className="mb-4" data-id="element-1157">
                            <h3 className="font-medium text-gray-900" data-id="element-1158">
                              Delivery Address
                            </h3>
                            <div className="flex items-start mt-1" data-id="element-1159">
                              <MapPinIcon className="h-5 w-5 text-gray-400 mr-1 flex-shrink-0" data-id="element-1160" />
                              <p className="text-sm text-gray-600" data-id="element-1161">
                                {order.address}
                              </p>
                            </div>
                          </div>
                          <div className="mb-4" data-id="element-1162">
                            <h3 className="font-medium text-gray-900" data-id="element-1163">
                              Order Summary
                            </h3>
                            <ul className="mt-1 space-y-1" data-id="element-1164">
                              {order.items.map((item, index) => <li key={index} className="text-sm text-gray-600" data-id="element-1165">
                                  {item.quantity} x {item.name}
                                </li>)}
                            </ul>
                          </div>
                          <div className="mb-4" data-id="element-1166">
                            <h3 className="font-medium text-gray-900" data-id="element-1167">
                              Order Total
                            </h3>
                            <p className="text-sm text-gray-600 mt-1" data-id="element-1168">
                              ₱{order.total.toFixed(2)}
                            </p>
                          </div>
                        </div>
                      </div>)}
                  </div>}
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
export default DeliveryDashboard;